import { MEMOAIR_AVATAR_URL } from "@dust-tt/front/types/assistant/avatar";
import type { SparkleContextImageType } from "@dust-tt/sparkle";
import { forwardRef, type ImgHTMLAttributes, useState } from "react";

// Avatars carry whatever URL was stored when the agent was created, so an asset
// that has since moved or gone offline renders as the browser's broken-image
// glyph. Fail over to the square, padded system avatar rather than the
// brand mark: the mark is a wide 265x194 logo crop, so `object-cover`-ing it
// into a square avatar slot zooms/crops it, looking inconsistent next to
// agents whose picture loaded fine.
export const BrandFallbackImage: SparkleContextImageType = forwardRef<
  HTMLImageElement,
  ImgHTMLAttributes<HTMLImageElement>
>(function BrandFallbackImage({ src, onError, ...props }, ref) {
  const [failedSrc, setFailedSrc] = useState<string | null>(null);

  return (
    <img
      ref={ref}
      src={src && src === failedSrc ? MEMOAIR_AVATAR_URL : src}
      onError={(event) => {
        if (src && src !== MEMOAIR_AVATAR_URL) {
          setFailedSrc(src);
        }
        onError?.(event);
      }}
      {...props}
    />
  );
});
